module.exports = __webpack_public_path__ + "img/documentation.d4b51724.png";